function wpAdminBarFunctions() {
  let wpAdminBar = document.querySelector('#wpadminbar');
  if (!wpAdminBar) return;
  let dontApplyToPagesInArray = [''];
  let $body = document.querySelector('body');
  let $sliceMenu = document.querySelector('.slice-slice');
  let $subMenuChecker = document.querySelector('.sup-menu input[type="checkbox"]');
  let $labelChecker = document.querySelector('[data-js="label-checker"]');

  document.addEventListener('click', () => {
    if (!$subMenuChecker.checked) {
      $labelChecker.style = 'padding-top:0';
      return;
    }
    
    $labelChecker.style = 'padding-top: ' + wpAdminBar.offsetHeight + 'px';
  });

  // Função para que o container principal se afaste do menu
  ['DOMContentLoaded', 'resize'].forEach(event => {
    let $dataPage = document.querySelector('[data-page]');
    let dataPage = $dataPage ? $dataPage.getAttribute('data-page') : false;

    if (dataPage && dontApplyToPagesInArray.indexOf(dataPage) !== -1) return;

    window.addEventListener(event, function (event) {
      $body.style = 'padding-top: ' + wpAdminBar.offsetHeight + 'px';

      if (document.documentElement.clientWidth < 1080) {
        if (!$sliceMenu) return;
        $sliceMenu.style = 'top: ' + wpAdminBar.offsetHeight + 'px';
      }
    });
  });

}

document.addEventListener('DOMContentLoaded', wpAdminBarFunctions);